module.exports = __webpack_public_path__ + "static/media/pic16.7ec0eb7d.jpg";